import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ViewIcon from "@material-ui/icons/Visibility";
import NumberFormat from "react-number-format";

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  },
  tableCellHead: {
    fontSize: "0.8rem",
    padding: "8px",
    fontWeight: 600
  },
  tableCell: {
    fontSize: "0.7rem",
    padding: "8px"
  }
}));

const Insurance = ({
  onChange,
  disabled,
  error,
  title,
  insurance,
  insurance_history,
  insurances,
  active_booking,
  ...props
}) => {
  const handleChange = event => {
    onChange(event, "insurance");
  };

  const classes = useStyles();

  const insurance_selected =
    insurance.insurance_id !== "" && insurance.insurance_id !== undefined
      ? insurances.filter(
          value => parseInt(value.id) === parseInt(insurance.insurance_id)
        )[0]
      : undefined;

  const formatDate = date => {
    //hansa_start_date = '2019-12-31'
    //return newDate[2]
    if (date == null || date === "") {
      return null;
    } else {
      if (date.includes("-")) {
        var dateParts = date.split("-");
        var day = dateParts[2];
        var month = parseInt(dateParts[1]);
        month = month < 10 ? "0" + month : month;
        var year = dateParts[0];
        return day + "/" + month + "/" + year;
      } else {
        var dateParts = date.split("/");
        var year = dateParts[2];
        var month = parseInt(dateParts[1]);
        month = month < 10 ? "0" + month : month;
        var day = dateParts[0];
        return year + "-" + month + "-" + day;
      }
    }
  };

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="insurance_id"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Seleccione el seguro
        </InputLabel>
        <Select
          native
          name="insurance_id"
          inputProps={{
            name: "insurance_id",
            className: "insurance_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          error={
            error !== "" && insurance.insurance_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={insurance.insurance_id}
          input={<Input id="grouped-native-select" name="insurance_id" />}
        >
          <option value="" />
          {insurances.map(insurance => (
            <option id={insurance.id} value={insurance.id}>
              {insurance.name}
            </option>
          ))}
        </Select>
      </FormControl>

      <TextField
        id="insurance_start_date"
        name="insurance_start_date"
        label="Fecha de alta"
        disabled={disabled}
        type="date"
        placeholder="Ingrese el monto asegurado"
        onChange={handleChange}
        value={insurance.insurance_start_date}
        margin="normal"
        className="mr-2 mt-3"
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />
      <NumberFormat
        id="insurance_ammount"
        name="insurance_ammount"
        placeholder="Ingrese el monto asegurado"
        label="Monto asegurado"
        onChange={handleChange}
        value={insurance.insurance_ammount}
        className="mr-2 mt-3"
        InputProps={{
          style: { fontSize: "0.75rem", width: 250 }
        }}
        decimalSeparator="."
        thousandSeparator=","
        prefix={"$"}
        customInput={TextField}
        InputLabelProps={{
          shrink: true
        }}
      />

      <TextField
        id="hansa_franchise"
        name="hansa_franchise"
        label="Franquicia reserva activa"
        disabled={true}
        type="text"
        value={active_booking ? active_booking.franchise : ""}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      {insurance_selected ? (
        <React.Fragment>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableCellHead}>
                  Aseguradora
                </TableCell>
                <TableCell className={classes.tableCellHead}>
                  Tipo de cobertura
                </TableCell>
                <TableCell className={classes.tableCellHead}>Broker</TableCell>
                <TableCell className={classes.tableCellHead}>
                  Detalle Cobertura
                </TableCell>
                <TableCell className={classes.tableCellHead}>
                  Número de poliza
                </TableCell>
                <TableCell className={classes.tableCellHead}>
                  Fecha de vigencia
                </TableCell>
                <TableCell className={classes.tableCellHead}>
                  Monto asegurado
                </TableCell>
                <TableCell className={classes.tableCellHead}>
                  Monto franquicia
                </TableCell>
                <TableCell className={classes.tableCellHead}>
                  Porcentaje franquicia
                </TableCell>
                <TableCell className={classes.tableCellHead}>&nbsp;</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableCell}>
                  {insurance_selected.producer.name}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  {insurance_selected.type.name}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  {insurance_selected.broker.name}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  {insurance_selected.coverage}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  {insurance_selected.policy_number}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  {formatDate(insurance_selected.start_date)} -{" "}
                  {formatDate(insurance_selected.end_date)}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  ${Number(insurance.insurance_ammount).toLocaleString("pt-BR")}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  ${insurance_selected.franchise_ammount}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  %{insurance_selected.franchise_percentage}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <ViewIcon
                    fontSize="small"
                    onClick={() =>
                      window.open("/insurance/" + insurance_selected.id + "/1")
                    }
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={10} style={{ textAlign: "center" }}>
                  Historial
                </TableCell>
              </TableRow>
              {insurance_history.map((val, idx) => {
                return (
                  <TableRow>
                    <TableCell className={classes.tableCell}>
                      {val.insurance.producer.name}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {val.insurance.type.name}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {val.insurance.broker.name}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {val.insurance.coverage}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {val.insurance.policy_number}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {formatDate(val.start_date)} - {formatDate(val.end_date)}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      ${Number(val.vehicle_ammount).toLocaleString("pt-BR")}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      ${Number(val.insurance_ammount).toLocaleString("pt-BR")}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      %{val.franchise_percentage}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <ViewIcon
                        fontSize="small"
                        onClick={() =>
                          window.open("/insurance/" + val.insurance.id + "/1")
                        }
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </React.Fragment>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};
export default Insurance;
